(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("contrast-dark-panelless", [], factory);
	else if(typeof exports === 'object')
		exports["contrast-dark-panelless"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["ContrastDarkPanelless"] = factory();
})(this, () => {
return 